import { ApiItemType } from '@ibe/api';
import { ItemRegistry } from '../../Models/ItemRegistry';

import * as Hotel from './Hotel';
import * as Flight from './Flight';
import * as Bus from './Bus';
import * as Base from './Base';
import * as Extra from './Extra';
import * as Package from './Package';
import * as RentalCar from './RentalCar';
import * as Transfer from './Transfer';
import * as Seat from './Seat';
import * as Insurance from './Insurance';

const Items: ItemRegistry = {
  [ApiItemType.HOTEL]: Hotel,
  [ApiItemType.TOUR]: Base,
  [ApiItemType.DINING]: Base,
  [ApiItemType.CAR]: RentalCar,
  [ApiItemType.TRANSPORT]: Base,
  [ApiItemType.FLIGHT]: Flight,
  [ApiItemType.BUS]: Bus,
  [ApiItemType.EXTRA]: Extra,
  [ApiItemType.INSURANCE]: Insurance,
  [ApiItemType.CRUISE]: Base,
  [ApiItemType.PACKAGE]: Package,
  [ApiItemType.PREDEFINEDPACKAGE]: Package,
  [ApiItemType.ROOM]: Base,
  [ApiItemType.ROOMRATE]: Base,
  [ApiItemType.TRANSFER]: Transfer,
  [ApiItemType.CHAUFFEUREDSERVICE]: Base,
  [ApiItemType.LOUNGEACCESS]: Base,
  [ApiItemType.AIRPORTTRANSFER]: Base,
  [ApiItemType.PREDEFINEDPACKAGE]: Base,
  [ApiItemType.MEETANDGREET]: Base,
  [ApiItemType.VOUCHER]: Base,
  [ApiItemType.CAMPER]: Base,
  [ApiItemType.SEAT]: Seat
};

export default Items;
